import { string, ref } from "yup";
import { LoginRegisterText } from "../LoginRegister-types";
import { emailValidationSchema } from "../../Shared/utils/formValidation";
//TODO: Export from shared instead of repeating?
/**
 * Func to provide error messages with field names (where possible).
 * @param fieldName
 * @returns String error message. E.g., "First Name field is required."
 */
const errMsg = (fieldName) => `${fieldName} is required.`;
export const registerFormSchema = {
    email: emailValidationSchema,
    firstName: string().required(errMsg(LoginRegisterText.FIRST_NAME)),
    lastName: string().required(errMsg(LoginRegisterText.LAST_NAME)),
    country: string().required(errMsg(LoginRegisterText.COUNTRY)),
    phone: string().required(errMsg(LoginRegisterText.PHONE)),
    password: string().required(errMsg(LoginRegisterText.PASSWORD)).min(6, LoginRegisterText.SHORT_PASSWORD),
    confirmPassword: string()
        .required(errMsg(LoginRegisterText.CONFIRM_PASSWORD))
        .oneOf([ref("password")], LoginRegisterText.PASSWORDS_MUST_MATCH),
};
